"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var vf_event_trigger_1 = require("./vf-event-trigger");
var vf_default_trigger_1 = require("./vf-default-trigger");
var vf_trigger_meta_1 = require("./interfaces/vf-trigger-meta");
var vf_ego_trigger_1 = require("./vf-ego-trigger");
var logger_1 = require("./util/logger");
var VFTriggerFactory = (function () {
    function VFTriggerFactory() {
    }
    VFTriggerFactory.CreateTrigger = function (meta, properties, scene) {
        var triggerName = meta.name;
        var node = scene.getNodeByName(triggerName);
        return VFTriggerFactory.CreateTriggerWithNode(meta, properties, scene, node);
    };
    VFTriggerFactory.CreateTriggerWithNode = function (meta, properties, scene, node) {
        var triggerName = meta.name;
        if (node != null && node instanceof babylonjs_1.TransformNode) {
            switch (meta.type) {
                case vf_trigger_meta_1.VFTriggerType.Event:
                case vf_trigger_meta_1.VFTriggerType.Ego:
                case vf_trigger_meta_1.VFTriggerType.Animation:
                    break;
                default:
                    if (triggerName.startsWith("vf_ego_")) {
                        meta.type = vf_trigger_meta_1.VFTriggerType.Ego;
                    }
                    else if (triggerName.startsWith("vf_event_")) {
                        meta.type = vf_trigger_meta_1.VFTriggerType.Event;
                    }
                    else {
                        meta.type = scene.getTriggerType(triggerName);
                    }
            }
            switch (meta.type) {
                case vf_trigger_meta_1.VFTriggerType.Event:
                    return new vf_event_trigger_1.default(triggerName, node, scene, meta, properties);
                case vf_trigger_meta_1.VFTriggerType.Ego:
                    return new vf_ego_trigger_1.default(triggerName, node, scene, meta, properties);
                case vf_trigger_meta_1.VFTriggerType.Animation:
                    logger_1.default.warn(triggerName + ": animation triggers are not supported yet");
                    return new vf_default_trigger_1.default(triggerName, node, scene, meta, properties);
                default:
                    logger_1.default.warn(triggerName + ": unknown trigger type \u2013 " + meta.type);
                    return new vf_default_trigger_1.default(triggerName, node, scene, meta, properties);
            }
        }
        else {
            logger_1.default.warn("no node found for name " + triggerName);
        }
        return null;
    };
    return VFTriggerFactory;
}());
exports.default = VFTriggerFactory;
